/**
 * The `{param|lower}` rule: lower-case the first letter only when it starts an
 * ordinary capitalised word ("Clicking" → "clicking"), so acronyms, quoted
 * names and symbols ("PDF export", "“Send”", "⌘S") stay as written. The
 * backend renders English fallbacks with the same rule.
 */
export function lowerFirst(value: string): string {
  const [first = "", second = ""] = value;
  const capitalisedWord =
    first !== first.toLowerCase() && second !== second.toUpperCase();
  return capitalisedWord ? first.toLowerCase() + value.slice(1) : value;
}
